import React from 'react';
import { Spinner } from 'components/UI';
import { Table } from 'components/UI/V3/Table/Table';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import styles from './CancellationNoShowsTable.module.scss';

import type { CancellationAndNoShowsReport } from 'model/CancellationAndNoShowsReport';

interface CancellationNoShowsTableProps {
    loading: boolean;
    report: CancellationAndNoShowsReport | null;
}

const fmtCurrency = (n: number) =>
    n.toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 0 });

const fmtPct = (ratio: number) => `${Math.round((ratio ?? 0) * 100)}%`;

// Ajusta labels si luego te pasan los nombres reales de reason_ids
const statusLabel = (statusId: number | string) => {
    if (statusId === 'total') return 'Total';

    switch (statusId) {
        case 1:
            return 'Mistake or Error';
        case 2:
            return 'Staff canceled';
        case 3:
            return 'Client canceled';
        case 4:
            return 'No Show';
        case 5:
            return 'Pet Decline';
        case 'no_reason':
            return 'No reason';
        default:
            return `Status ${statusId}`;
    }
};

export default function CancellationNoShowsTable(props: CancellationNoShowsTableProps) {
    const rows = props.report?.rows ?? [];

    return (
        <Table fullHeight>
            <TableHeader>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>Total Bookings</TableHeaderCell>
                <TableHeaderCell>Total Value</TableHeaderCell>
                <TableHeaderCell>Deposit Collected</TableHeaderCell>
                <TableHeaderCell>Rebooked</TableHeaderCell>
                <TableHeaderCell>Not Rebooked</TableHeaderCell>
                <TableHeaderCell>Missed Revenue</TableHeaderCell>
            </TableHeader>

            <TableBody>
                {props.loading ? (
                    <TableRow>
                        <TableCell
                            colSpan={7}
                            className={styles.loadingCell}
                        >
                            <Spinner className={styles.spinner} />
                        </TableCell>
                    </TableRow>
                ) : (
                    rows.map((row, idx) => {
                        const isTotal = row.statusId === 'total';
                        const emphasis = isTotal ? styles['cell-emphasis'] : '';

                        return (
                            <TableRow key={idx}>
                                <TableCell className={emphasis}>{statusLabel(row.statusId)}</TableCell>
                                <TableCell>{row.totalBookings}</TableCell>
                                <TableCell>{fmtCurrency(row.totalValue)}</TableCell>
                                <TableCell>{fmtCurrency(row.depositCollected)}</TableCell>
                                <TableCell>
                                    {row.rebooked.value} ({fmtPct(row.rebooked.pct)})
                                </TableCell>
                                <TableCell>
                                    {row.notRebooked.value} ({fmtPct(row.notRebooked.pct)})
                                </TableCell>
                                <TableCell>{fmtCurrency(row.missedRevenue)}</TableCell>
                            </TableRow>
                        );
                    })
                )}
            </TableBody>
        </Table>
    );
}
